import overviewRouterPaths from './overviewRouterPaths';

export default overviewRouterPaths;
